@if (!showVerification) {
  <div [ngClass]="{formpadding: anonymousNewRequest.canSubmitLeaveRequests || anonymousNewRequest.canSubmitLeaveHourRequests}">
    <app-account-form
      [sysText]="sysText$ | async"
      [options]="options"
      [page]="templateName"
      [isSubmitting]="isSubmitting$ | async"
      [usernameOrEmail]="username"
      (formSubmit)="onFormSubmit($event)">
    </app-account-form>
  </div>
  @if (anonymousNewRequest.canSubmitLeaveRequests || anonymousNewRequest.canSubmitLeaveHourRequests) {
    <app-anonymous-option
      [canSubmitLeaveRequests]="anonymousNewRequest.canSubmitLeaveRequests"
      [canSubmitLeaveHourRequests]="anonymousNewRequest.canSubmitLeaveHourRequests"
      [sysText]="sysText$ | async">
    </app-anonymous-option>
  }
}

@if (showVerification) {
  <app-verification-form
    [sysText]="sysText$ | async"
    [options]="verificationOptions"
    [selectedProviders] ="selectedProviders"
    [page]="templateName"
    [otpDest]="otpDest"
    [otpIsPhone]="otpIsPhone"
    [isSubmitting]="isSubmitting$ | async"
    (formSubmit)="onVerificationSubmit($event)"
    (sendCode)="handleSendCode($event)"
    (goBack)="onGoBack()">
  </app-verification-form>
}